import {Collection} from 'common'
import 'model/projectdef'
Collection.define('collection.hierarchy', {
  model: 'ycctrl.projectdef',
  proxy: {
    get: '/cpu-supplymgr/supplyMgrBaseDoc/supplyAbility/pageQuery'
  }
})
// /cpu-supplymgr/supplyMgrBaseDoc//supplyAbility/pageQuery
export default Collection.create('collection.hierarchy')



// WEBPACK FOOTER //
// ./src/data/collection/hierarchy/index.js